<template>
  <div class="etms-router-body">
    <div class="file-upload-content fl">
      <ul>
        <li>
          <el-select size="mini" placeholder="请选择客户"></el-select>
        </li>
        <li>
          <el-select size="mini" placeholder="请选择发货渠道"></el-select>
        </li>
        <li>
          <el-upload ref="upload" :action="fileuploadurl" :before-remove="beforeRemove" :limit="1" :on-exceed="handleExceed" :file-list="fileList" :auto-upload="false" list-type="text">
            <el-button slot="trigger" size="mini" type="primary">选择文件</el-button>
            <el-button style="margin-left:10px;" size="mini" type="success" @click="submitUpload">上传到服务器</el-button>
            <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过2mb</div>
          </el-upload>
        </li>
        <li></li>
      </ul>
    </div>
    <div class="file-upload-content fl">
      <el-tabs type="border-card" v-model="activePane" @tab-click="handleClick">
        <el-tab-pane label="模版" name="template">
          <div class="excel-template-body">
            平台模版
            <ul class="excel-template-content">
              <li v-for="item in templates" :key="item.TemplateId" class="template-list fl" @click="exceldownload(item.TemplatePath)">
                <div>
                  <img src="/static/excel.png" alt="" />
                </div>
                <a v-bind="item.TemplatePath">
                  {{item.TemplateName}}
                </a>
              </li>
            </ul>
          </div>
          <div class="clear"></div>
          <div class="excel-template-body">
            <span class="fl">自定义模版</span>
            <el-tooltip class="item" effect="dark" content="上传自定义模版" placement="top">
              <el-button type="primary" size="mini" icon="el-icon-plus" class="fr" circle @click="inserttemplate=true"></el-button>
            </el-tooltip>
            <div class="clear"></div>
            <ul class="excel-template-content">
              <li v-for="item in customtemplates" :key="item.TemplateId" class="template-list fl">
                <div>
                  <i class='el-icon-circle-close template-close' @click="excelDelete(item.TemplateId)"></i>
                  <i class='el-icon-edit-outline template-edit' @click="excelEdit(item.TemplateId)"></i>
                  <img src="/static/excel.png" alt="" />
                </div>
                <a v-bind="item.TemplatePath">
                  {{item.TemplateName}}
                </a>
              </li>
            </ul>
          </div>
        </el-tab-pane>
        <el-tab-pane label="注意事项" name="second">
          1、上传时请将excel文件的表格名改为对应的模版名称<br />
          2、国家请填写完整国家中文名或者英文名、代码并与平台公示国家信息保持一致<br />
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog title="添加自定义模版" :visible.sync="inserttemplate" :modal-append-to-body="false" width="350px" center>
      <ul>
        <li>
          <el-input size="mini" placeholder="请填写模版名称(默认用文件名代替)" class="el-width-300"></el-input>
        </li>
        <li>
          <el-upload class="upload-demo" ref="upload" :action="templateuploadurl" :before-remove="beforeRemove" :limit="1" :on-exceed="handleExceed" :file-list="fileList" :auto-upload="false" list-type="text">
            <el-button slot="trigger" size="mini" type="primary">选择文件</el-button>
            <el-button style="margin-left:10px;" size="mini" type="success" @click="submitTemplateUpload">上传到服务器</el-button>
            <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过2mb</div>
          </el-upload>
        </li>
      </ul>
    </el-dialog>
    <el-dialog title="模版绑定" :visible.sync="templatebind" :modal-append-to-body="false" center width="750px">
      <div style="height:400px;">
        <div class="template-bind-left fl">
          <el-table :data="customwaybillcolumns" height="400px" border class="etms-router-list">
            <el-table-column label="选择" width="50px" align="center">
              <template slot-scope="scope">
                <el-checkbox v-model='scope.row.checked' @change="customColumnChange(scope.row)"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column type="index" label="序号" align="center"></el-table-column>
            <el-table-column label="自定义字段" prop="label">
            </el-table-column>
          </el-table>
        </div>
        <div class="template-handle fl">
          <div style="margin-top:180px">
            <el-tooltip content="取消绑定" placement="top" class="item" effect="dark">
              <el-button size="mini" icon="el-icon-arrow-left" circle @click="removeColumnBind"></el-button>
            </el-tooltip>
            <div style="padding-top:10px;"></div>
            <el-tooltip content="绑定" placement="top" class="item" effect="dark">
              <el-button size="mini" icon="el-icon-arrow-right" circle @click="insertColumnBind"></el-button>
            </el-tooltip>
          </div>
        </div>
        <div class="template-bind-right fl">
          <el-table :data="waybillcolumns" height="400px" border class="etms-router-list">
            <el-table-column label="选择" width="50px" align="center">
              <template slot-scope="scope">
                <el-checkbox v-model='scope.row.checked' @change="waybillColumnChange(scope.row)"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column type="index" label="序号" align="center"></el-table-column>
            <el-table-column label="运单字段" prop="label">
            </el-table-column>
            <el-table-column label="绑定字段" prop="customcolumn"></el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  data () {
    return {
      fileuploadurl: this.constant.openPaths.fileupload,
      templateuploadurl: this.constant.openPaths.fileupload,
      waybillcolumns: this.constant.waybillcolumns,
      customwaybillcolumns: [
        { label: '客户单号', value: 'customerodd', checked: false, customcolumn: '' },
        { label: '服务商单号', value: 'ServiceOdd', checked: false, customcolumn: '' },
        { label: '发货商', value: 'TargetEnterprise', checked: false, customcolumn: '' },
        { label: '渠道', value: 'Channel', checked: false, customcolumn: '' },
        { label: '包裹分类', value: 'ParcelType', checked: false, customcolumn: '' },
        { label: '是否退件', value: 'NeedReturn', checked: false, customcolumn: '' },
        { label: '数量', value: 'ConfirmQuantity', checked: false, customcolumn: '' },
        { label: '箱号', value: 'CaseNumber', checked: false, customcolumn: '' },
        { label: '子单号', value: 'ParcelOdd', checked: false, customcolumn: '' },
        { label: '重量', value: 'ParcelConfirmWeight', checked: false, customcolumn: '' },
        { label: '长', value: 'ParcelConfirmLong', checked: false, customcolumn: '' },
        { label: '宽', value: 'ParcelConfirmWide', checked: false, customcolumn: '' },
        { label: '高', value: 'ParcelConfirmHigh', checked: false, customcolumn: '' },
        { label: '收货人', value: 'ReceiptName', checked: false, customcolumn: '' },
        { label: '收货公司', value: 'ReceiptCompanyName', checked: false, customcolumn: '' },
        { label: '目的国家', value: 'PurposeRegion', checked: false, customcolumn: '' },
        { label: '目的机场 港口 仓库', value: 'PurposeAirPortDepot', checked: false, customcolumn: '' },
        { label: '目的州省', value: 'ReceiptState', checked: false, customcolumn: '' },
        { label: '目的城市', value: 'ReceiptCity', checked: false, customcolumn: '' },
        { label: '目的区县', value: 'ReceiptCounty', checked: false, customcolumn: '' },
        { label: '目的街道', value: 'ReceiptStreet', checked: false, customcolumn: '' },
        { label: '收货详细地址', value: 'ReceiptAddress', checked: false, customcolumn: '' },
        { label: '收货备用地址', value: 'ReceiptStandbyAddress', checked: false, customcolumn: '' },
        { label: '收货方手机', value: 'ReceiptMobile', checked: false, customcolumn: '' },
        { label: '收货方电话', value: 'ReceiptPhone', checked: false, customcolumn: '' },
        { label: '收货方传真', value: 'ReceiptFax', checked: false, customcolumn: '' },
        { label: '收货方邮编', value: 'BuyerZipcode', checked: false, customcolumn: '' },
        { label: '收货方邮箱', value: 'ReceiptEmail', checked: false, customcolumn: '' },
        { label: '平台买家ID', value: 'BuyerCode', checked: false, customcolumn: '' },
        { label: '寄件人', value: 'SenderName', checked: false, customcolumn: '' },
        { label: '寄件公司', value: 'SenderCompanyName', checked: false, customcolumn: '' },
        { label: '寄件州省', value: 'SenderState', checked: false, customcolumn: '' },
        { label: '起运机场 港口 仓库', value: 'ShipmentAirPortDepot', checked: false, customcolumn: '' },
        { label: '寄件城市', value: 'SenderCity', checked: false, customcolumn: '' },
        { label: '寄件区县', value: 'SenderCounty', checked: false, customcolumn: '' },
        { label: '寄件街道', value: 'SenderStreet', checked: false, customcolumn: '' },
        { label: '寄件详细地址', value: 'SenderAddress', checked: false, customcolumn: '' },
        { label: '寄件备用地址', value: 'SenderStandbyAddress', checked: false, customcolumn: '' },
      ],
      inserttemplate: false,
      templatebind: false,
      fileList: [],
      activePane: 'template',
      waybillcolumn: '',
      templates: [
        {
          TemplateId: '0',
          TemplateName: '完整模版',
          TemplatePath: '/static/运单导入模版.xlsx'
        }, {
          TemplateId: '1',
          TemplateName: '完整模版',
          TemplatePath: '/static/运单导入模版.xlsx'
        }, {
          TemplateId: '2',
          TemplateName: '完整模版',
          TemplatePath: '/static/运单导入模版.xlsx'
        }, {
          TemplateId: '3',
          TemplateName: '完整模版',
          TemplatePath: '/static/运单导入模版.xlsx'
        }, {
          TemplateId: '4',
          TemplateName: '完整模版',
          TemplatePath: '/static/运单导入模版.xlsx'
        }, {
          TemplateId: '5',
          TemplateName: '完整模版',
          TemplatePath: '/static/运单导入模版.xlsx'
        }
      ],
      customtemplates: [
        {
          TemplateId: '7',
          TemplateName: '完整模版',
          TemplatePath: '/static/运单导入模版.xlsx'
        }
      ]
    };
  },
  methods: {
    handleRemove (file, fileList) {
      console.log(file, fileList);
    },
    handlePreview (file) {
      console.log(file);
    },
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove (file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    submitUpload () {
      this.$refs.upload.submit()
    },
    submitTemplateUpload () { },
    handleClick (tab, event) {
      console.log(tab, event);
    },
    exceldownload (path) {
      alert(path)
      window.location.href = path
    },
    excelDelete (TemplateId) {
      this.$confirm('此操作将永久删除该模版及文件,是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({ type: 'success', message: '删除成功！' })
      }).catch(() => {
        this.$message({ type: 'info', message: '取消删除' })
      })
    },
    excelEdit (TemplateId) {
      this.templatebind = true
    },
    customColumnChange (row) {
      if (row.checked) {
        this.customwaybillcolumns.filter(item => item.value !== row.value).forEach((item, index) => {
          item.checked = false
        })
      }
    },
    waybillColumnChange (row) {
      if (row.checked) {
        this.waybillcolumns.filter(item => item.value !== row.value).forEach((item, index) => {
          item.checked = false
        })
      }
    },
    insertColumnBind () {
      var customwaybillcolumn = this.customwaybillcolumns.filter(item => item.checked)[0]
      var waybillcolumn = this.waybillcolumns.filter(item => item.checked)[0]

      if (customwaybillcolumn != null && customwaybillcolumn != undefined && waybillcolumn != null && waybillcolumn != undefined) {
        waybillcolumn.customcolumn = customwaybillcolumn.label
      }
    },
    removeColumnBind () {
      var waybillcolumn = this.waybillcolumns.filter(item => item.checked)[0]

      if (waybillcolumn != null && waybillcolumn != undefined) {
        waybillcolumn.customcolumn = ''
      }
    }
  }
}
</script>

<style scoped>
@import "../../../css/etms/home.css";
@import "../../../css/iconfont.css";

.etms-router-body .file-upload-content {
  width: 50%;
  padding: 0;
  margin: 0;
  text-align: left;
}

.excel-template-body {
  padding: 10px 0;
}

ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
li {
  padding: 5px;
}

.excel-template-body .template-list {
  width: 130px;
  cursor: pointer;
  text-align: center;
}

.excel-template-body .template-list > a {
  color: #414141;
}

.excel-template-body .template-list:hover > a {
  color: #06f;
}

.excel-template-body .template-list > div {
  position: relative;
}

.template-close {
  top: 0;
  right: 18px;
  position: absolute;
  cursor: pointer;
}

.template-edit {
  top: 0;
  right: 33px;
  position: absolute;
  cursor: pointer;
}

.template-bind-left {
  width: 35%;
  height: 400px;
}
.template-bind-right {
  width: 55%;
  height: 400px;
}

.template-handle {
  width: 10%;
  height: 400px;
  text-align: center;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/etms/tms/import_waybill.vue